// import {xxApi} from '@/api'

const actions = {
  // 发送消息
  async acSetMessage({ commit, state, rootState, rootGetters }, params) {
    commit('muSetMessage', 'Hello!!');
  }
};
export default actions;
